import { DATA_01 as DATA_INSTRUMENT_01 } from './instruments.data';
import { ICcypair, ISO4217 } from '@alk/currency';
import { IPadResult } from '../interfaces';
import { Tenor } from '@alk/dates';
import { TRADE_PAD_DEFAULT_SETTINGS } from './pad-config.data';

export const DATA_01: IPadResult = {
    id: 'someId',
    resolvedTenors: [],
    quote: undefined,
    instrument: {
        symbol: DATA_INSTRUMENT_01.symbol as ICcypair,
        roundLot: DATA_INSTRUMENT_01.roundLot,
        minimumTradeVolume: DATA_INSTRUMENT_01.minTradeQty,
        fractionSize: DATA_INSTRUMENT_01.fractionSize,
        extraDigitSupport: DATA_INSTRUMENT_01.extraDigital,
        extraDigitSize: 1,
        settlementPeriodInDays: 2,
    },
    instruments: [],
    allInstruments: [],
    tradedCurrency: 'EUR' as ISO4217,
    isStartRequested: false,
    isQuoteFeedAlive: false,
    quantity: 0,
    date: 'SP' as Tenor,
    productType: 'spot',
    spotType: 'full',
    pendingType: 'limit',
    config: TRADE_PAD_DEFAULT_SETTINGS,
    hasConfirmation: true,
    expiryDate: undefined,
    expiryType: 'gtc',
    triggerPrice: 1.2345,
    tradingDisabled: false,
    displaySpread: true,
    isCurrencyInversionForESPEnable: true,
    isCurrencyInversionForRFSEnable: true,
    availableOrderTypes: [ 'full', 'limit' ],
};
